export const Paths = {
  home: { url: "/*" },
  search: { url: "/search" },
  confirmation: { url: "/confirmation" },
  checkout: { url: "/checkout" },
  detailsPage: { url: "/items/*" },
  hardwareSearch: { url: "/hardware" },
  approval: { url: "/order/:orderId" },
  orders: { url: "/orders" },
  lists: { url: "/lists" },
  ordersApproval: { url: "/ordersApproval" },
  whatsNew: { url: "/aiforme/whatsNew" },
  aiformeIntake: { url: "/aiforme/contribute" },
  aiforme: { url: "/aiforme" },
  aiformeMyTools: { url: "/aiforme/mytools" },
  aiForMeLists: { url: "/aiforme/lists" },
  aiForMeAdminLists: { url: "/aiforme/admin/lists" },
  aiForMeAllAiTools: { url: "/aiforme/allAiTools" },
  aiForMeUseCases: { url: "/aiforme/usecases" },
  aiForMeUseCaseDetail: { url: "/aiforme/usecases/detail/:id+" },
  aiForMeUseCaseContribute: { url: "/aiforme/usecases/contribute" },
  aiForMeUseCaseDashboard: { url: "/aiforme/usecases/dashboard" },
  sessionExpired: { url: "/session-expired" },
  spaces: { url: "/aiforme/spaces/:spaceAlias" },
  spacesExplore: { url: "/aiforme/spaces" },
  notFound: { url: "/*" },
  faq: { url: "/faq" },
  oldAiFormeHomePage: { url: "/aiforme/oldHomePageHiddenToUsers" },
} as const;
